import { NSARouterMakerResult } from "namirasoft-account-react";
import { ServiceTypeInputRow, ServiceTypeRow } from "namirasoft-erp";
import { NSBox, NSBoxString, NSBoxTextArea, NSColumn } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { ErpEntities } from "../ErpEntities";
import { ErpLayout } from '../ErpLayout';
import { ErpRouterProps } from "../ErpRouterProps";
import { ErpScope, ErpScopeField, ErpScopeMode } from "../ErpScope";

interface Props extends NSARouterMakerResult, ErpRouterProps { isEdit: boolean; }

export default class ServiceTypeEditPage extends Component<Props>
{
    Name = createRef<NSBoxString>();
    Description = createRef<NSBoxTextArea>();

    override render()
    {
        return (
            <ErpLayout<ServiceTypeRow, ServiceTypeInputRow>
                {...this.props}
                mode={ErpScopeMode.Select}
                fields={[ErpScopeField.Company, ErpScopeField.Branch]}
                pages={{
                    entity: ErpEntities.service_type(this.props),
                    edit: {
                        ...this.props,
                        ui: {
                            tab_page_edit: {
                                editor: {
                                    getInputRow: (): ServiceTypeInputRow => ({
                                        company_id: ErpScope.getCompanyId() ?? "",
                                        branch_id: ErpScope.getBranchId() ?? "",
                                        name: this.Name.current?.getValue() ?? "",
                                        description: this.Description.current?.getValue() ?? null,
                                        service_type_category: [],
                                        service_type_tag: [],
                                        service_type_field: [],
                                    }),
                                    setRow: (row: ServiceTypeRow) =>
                                    {
                                        ErpScope.set({ company_id: row.company_id, branch_id: row.branch_id });
                                        this.Name.current?.setValue(row.name);
                                        this.Description.current?.setValue(row.description);
                                    }
                                }
                            }
                        }
                    }
                }}
            >
                <NSColumn>
                    <NSBoxString ref={this.Name} required title="Name" info={{ link: "https://namirasoft.com/erp/console-guide/service-type/#field-name" }} style={{ width: NSBox.width.double }} />
                    <NSBoxTextArea ref={this.Description} required={false} title="Description" info={{ link: "https://namirasoft.com/erp/console-guide/service-type/#field-description" }} style={{ width: NSBox.width.double }} />
                </NSColumn>
            </ErpLayout>
        );
    }
}